// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTrash as RawLucideTrash } from "lucide-react";
export const LucideTrash = /* @__PURE__ */ createIcon(RawLucideTrash, "LucideTrash", 2);
